import React from 'react';
import { AppFeature } from '@types';
// Import images using ES Modules
import halfLemonsImage from '@images/half-lemons.png';
import dinnersAppImage from '@images/dinners-app.png';
import streakPulseImage from '@images/streak-pulse.png';
import thinkGloballyImage from '@images/think-globally.jpg';
import gainsImage from '@images/gains.png';

// Define features data
const appFeatures: AppFeature[] = [
  {
    id: 'half-lemons',
    title: 'Half Lemons',
    image: halfLemonsImage,
    imageAlt: 'Half Lemons iOS App by Theo Goodman - Find recipes using your ingredients.',
    description: 'Recipes using your ingredients.',
    link: 'https://www.halflemons.com',
    linkText: 'www.halflemons.com'
  },
  {
    id: 'gains',
    title: 'Gains',
    image: gainsImage,
    imageAlt: 'Gains Clothing by Theo Goodman - Gains apparel.',
    description: 'Fitness apparel.',
    link: 'https://gainsapparel.netlify.app',
    linkText: 'gainsapparel.netlify.app'
  },
  {
    id: 'dinners-app',
    title: 'Dinners App',
    image: dinnersAppImage,
    imageAlt: 'Dinners App by Theo Goodman - Tinder-style recipe matching app.',
    description: 'Tinder for recipes.',
    link: 'https://www.dinnersapp.com',
    linkText: 'www.dinnersapp.com'
  },
  {
    id: 'streak-pulse',
    title: 'Streak Pulse',
    image: streakPulseImage,
    imageAlt: 'Streak Pulse iOS App by Theo Goodman - Gamified task management and habit tracking',
    description: 'Gamify your habits.',
    link: 'https://www.streakpulse.com',
    linkText: 'www.streakpulse.com'
  },
  {
    id: 'think-globally',
    title: 'Think Globally, Live Locally',
    image: thinkGloballyImage,
    imageAlt: 'Think Globally Live Locally by Theo Goodman - Curated travel guide platform',
    description: 'Curated travel guide.',
    link: 'https://www.thinkgloballylivelocally.com',
    linkText: 'www.thinkgloballylivelocally.com'
  }
];

const AppFeatures: React.FC = () => {
  return (
    <div>
      <h3 className="text-lg font-light text-black mb-4">My Apps</h3>
      <div className="rounded-lg pl-4 sm:pl-0">
        <div className="grid grid-cols-2 sm:flex sm:flex-col gap-6 sm:gap-6">
          {appFeatures.map((feature, index) => (
            <div key={feature.id} className="flex flex-col sm:flex-row sm:items-center">
              <div className="w-full sm:w-32 mt-2 sm:mt-5">
                <p className="text-gray-400 text-xs">
                  {index === 4 ? 'Web app' : 
                   index === 1 ? 'Ecommerce app' : 'iPhone app'}
                </p>
              </div>
              <div className={`sm:ml-6 ${index === 1 || index === 4 ? 'w-full sm:w-[calc(30%)]' : 'w-full sm:w-[calc(15%)]'}`}>
                <h4 className="text-base sm:text-sm font-light text-black break-words sm:whitespace-nowrap">{feature.title}</h4>
                <p className="text-gray-500 text-sm font-light mb-1 -mt-1 break-words sm:whitespace-nowrap">
                  {feature.description}
                  {feature.id === 'gains' && <span className="block sm:hidden">&nbsp;</span>}
                </p>
                <a href={feature.link} className="block" target="_blank" rel="noopener noreferrer">
                  <img 
                    src={feature.image} 
                    alt={feature.imageAlt} 
                    className={`${index === 1 || index === 4 ? 'w-5/6 sm:w-full' : 'w-4/5 sm:w-full'} ${index === 1 || index === 4 ? 'aspect-video' : 'aspect-square'} object-cover rounded-xl transition-transform duration-300 sm:hover:scale-105`}
                  />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AppFeatures;